'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _uniqueId = require('lodash/uniqueId');var _uniqueId2 = _interopRequireDefault(_uniqueId);
var _findIndex = require('lodash/findIndex');var _findIndex2 = _interopRequireDefault(_findIndex);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _reactScroll = require('react-scroll');
var _components = require('../../components');

var _PublishPropertyForm = require('../../containers/PublishForm/PublishPropertyForm.scss');var styles = _interopRequireWildcard(_PublishPropertyForm);
var _constants = require('../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var UploadPhotoBlock = function (_Component) {_inherits(UploadPhotoBlock, _Component);function UploadPhotoBlock(props) {_classCallCheck(this, UploadPhotoBlock);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.























    formatInitialImages = function () {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      _this.formattedImages = data.map(function (_ref)







      {var publicId = _ref.public_id,description = _ref.description,angle = _ref.angle,relativeAngle = _ref.relativeAngle,full = _ref.full,thumbnail = _ref.thumbnail,_ref$_id = _ref._id,_id = _ref$_id === undefined ? (0, _uniqueId2.default)('upload_image_') : _ref$_id;
        // Initial angle calculation
        var imageAngle = _components.UploadAssetWidget.getAngle({ angle: angle, full: full });
        var linkId = publicId || full && full.split('/').pop();

        return {
          thumbnail: thumbnail,
          full: full,
          link: linkId,
          description: description,
          angle: imageAngle,
          relativeAngle: relativeAngle || 0,
          contentType: _constants.cloudinaryContentTypes.IMAGE,
          _id: _id };

      });

      return _this.formattedImages;
    };_this.

    formatInitialVideos = function () {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var baseUrl = (0, _constants.getAssetsBaseUrl)(_constants.cloudinaryContentTypes.VIDEO);

      _this.formattedVideos = data.map(function (_ref2)






      {var publicId = _ref2.public_id,id = _ref2.id,description = _ref2.description,full = _ref2.full,_ref2$_id = _ref2._id,_id = _ref2$_id === undefined ? (0, _uniqueId2.default)('upload_image_') : _ref2$_id,source = _ref2.source;
        var linkId = id || publicId || full && full.split('/').pop();

        return {
          thumbnail: baseUrl + '/' + _constants.thumbnailModifier + '/' + linkId + '.jpg',
          full: baseUrl + '/' + _constants.fullModifier + '/' + linkId,
          link: linkId,
          description: description,
          angle: 0,
          source: source,
          contentType: _constants.cloudinaryContentTypes.VIDEO,
          _id: _id,
          id: id };

      });

      return _this.formattedVideos;
    };_this.

    changeImages = function (data) {
      var photos = _this.formattedImages || _this.formatInitialImages(data);

      _this.props.changeValue('images', photos);
    };_this.

    changeVideos = function (data) {
      var videos = _this.formattedVideos || _this.formatInitialVideos(data);

      _this.props.changeValue('videos', videos);
    };_this.

    contentUploaded = function (data, uploadedContent, key) {
      _this.updateContent(data, key);
    };_this.

    deleteContentItem = function (id, key) {
      var formData = _this.props[key].map(function (item) {return Object.assign({}, item);});
      var index = (0, _findIndex2.default)(formData, function (item) {return item._id === id;});
      formData.splice(index, 1);

      _this.updateContent(formData, key);
    };_this.

    rotateImage = function (id, newAngle) {
      var formImages = _this.props.images.map(function (img) {
        var angle = img.angle;
        if (id === img._id) {
          angle = newAngle;
        }

        return Object.assign({}, img, { angle: angle });
      });

      _this.updateContent(formImages, 'images');
    };_this.

    addDescription = function (id, newDescription, key) {
      var formData = _this.props[key].map(function (item) {
        var description = item.description;
        if (id === item._id) {
          description = newDescription;
        }

        return Object.assign({}, item, { description: description });
      });

      _this.updateContent(formData, key);
    };_this.

    updateContent = function (data, key) {return _this.props.changeValue(key, data);};_this.state = { showRequiredImagesTooltip: props.showRequiredImagesTooltip, showTooltip: true };return _this;}UploadPhotoBlock.prototype.componentDidMount = function componentDidMount() {this.props.registerNewField('videos');if (this.props.images) {this.changeImages(this.props.images);}if (this.props.videos) {this.changeVideos(this.props.videos);}};UploadPhotoBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.showRequiredImagesTooltip !== this.props.showRequiredImagesTooltip) {this.setState({ showRequiredImagesTooltip: nextProps.showRequiredImagesTooltip });}};UploadPhotoBlock.prototype.

  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', { className: styles.imageSectionBlock },
        _react2.default.createElement('div', { className: styles.title },
          this.props.translate('sections', 'photo')),


        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.requiredFieldWrapper, styles.uploadImageWrapper) },
          _react2.default.createElement(_components.UploadAssetWidget, {
            multiple: true,
            translate: this.props.translate,
            rootTranslate: this.props.rootTranslate,
            initialImages: this.props.images && (this.formattedImages || this.formatInitialImages(this.props.images)),
            initialVideos: this.props.videos && (this.formattedVideos || this.formatInitialVideos(this.props.videos)),
            uploadInProgress: this.props.changeUploadingStatus,
            contentUploaded: this.contentUploaded,
            markAssetToDelete: this.props.addAssetToDelete,
            isMobile: this.props.isMobile,
            className: this.props.className,
            uploadImageTimeout: this.props.uploadImageTimeout,
            updateContent: this.updateContent,
            deleteContentItem: this.deleteContentItem,
            rotateImage: this.rotateImage,
            addDescription: this.addDescription,
            openMessageModal: this.props.openMessageModal,
            userToken: this.props.token,
            isInvalid: this.props.isInvalid,
            suspendedUpload: true }),

          !this.props.isMobile && this.state.showTooltip &&
          _react2.default.createElement('div', { className: styles.imageTooltip },
            _react2.default.createElement(_components.PublishFormImagesTooltip, {
              translate: this.props.translate,
              hideTooltip: function hideTooltip() {return _this2.setState({ showTooltip: false });} })),



          !this.props.isMobile && this.state.showRequiredImagesTooltip &&
          _react2.default.createElement('div', { className: styles.requiredImageTooltip },
            _react2.default.createElement(_components.PublishFormRequiredImagesTooltip, {
              translate: this.props.translate,
              hideTooltip: function hideTooltip() {return _this2.setState({ showRequiredImagesTooltip: false });} })),



          _react2.default.createElement('div', { className: styles.sizeMessage }, this.props.rootTranslate('uploadWidget', 'fileSizeMessage')))));



  };return UploadPhotoBlock;}(_react.Component);exports.default = UploadPhotoBlock;


UploadPhotoBlock.propTypes = {
  images: _propTypes2.default.array,
  videos: _propTypes2.default.array,
  token: _propTypes2.default.string,
  translate: _propTypes2.default.func.isRequired,
  rootTranslate: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool,
  changeValue: _propTypes2.default.func.isRequired,
  registerNewField: _propTypes2.default.func.isRequired,
  changeUploadingStatus: _propTypes2.default.func.isRequired,
  addAssetToDelete: _propTypes2.default.func,
  className: _propTypes2.default.string,
  uploadImageTimeout: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  isInvalid: _propTypes2.default.bool,
  showRequiredImagesTooltip: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadPhotoBlock/UploadPhotoBlock.js
// module id = 2931
// module chunks = 0